import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { Button } from "../components/ui/button";
import SEOHead from "../components/SEOHead";
import Navigation from "../components/Navigation";
import Hero from "../components/Hero";
import LeadMagnet from "../components/LeadMagnet";
import Services from "../components/Services";
import About from "../components/About";
import Resources from "../components/Resources";
import Testimonials from "../components/Testimonials";
import Booking from "../components/Booking";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import { useScrollspy } from "../hooks/useScrollspy";

export default function Home() {
  const [showBackToTop, setShowBackToTop] = useState(false);
  const activeSection = useScrollspy();

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.pageYOffset > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Handle URL hash navigation on page load (e.g., /#booking or /#lead-magnet)
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const timer = setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 300);
      return () => clearTimeout(timer);
    }
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <SEOHead 
        title="Grow & Stay Rich | Generational Wealth & Tax-Free Retirement Strategies"
        description="Empowering families and business leaders with tax-advantaged capital accumulation, 0% market downside protection, and Living Benefits."
        path="/"
      />
      <Navigation activeSection={activeSection} />
      <Hero />
      <LeadMagnet />
      <Services />
      <About />
      <Resources />
      <Testimonials />
      <Booking />
      <Contact />
      <Footer />
      
      {/* Back to Top Button */}
      <Button
        onClick={scrollToTop}
        className={`fixed bottom-8 right-8 bg-primary hover:bg-primary/90 text-primary-foreground w-12 h-12 rounded-full shadow-lg transition-all duration-300 ${
          showBackToTop ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
        size="icon"
      >
        <ArrowUp className="h-6 w-6" />
      </Button>
    </>
  );
}
